import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import delete_icon from "../../assets/images/delete.svg";
import { Link } from "react-router-dom";
import Loader from "../Loader";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../context/AppContext";

const animations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
};

const AddOnSettingsCart = () => {
    const { t } = useTranslation();

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const { sidebar } = useContext(AppContext)

    // Mock loader
    const [loader] = useState(false);

    // Mock cart data
    const [addOnmyCardList, setAddOnmyCardList] = useState([
        {
            addon_info_name: "Premium Analytics",
            addon_pricing_addon_subscription_price: 25,
            addon_pricing_addon_price: 10,
            addon_pricing_addon_subscription_period: "monthly",
            currency_symbol: "$",
        },
        {
            addon_info_name: "Advanced Reports",
            addon_pricing_addon_subscription_price: 40,
            addon_pricing_addon_price: 15,
            addon_pricing_addon_subscription_period: "annually",
            currency_symbol: "$",
        },
    ]);

    const handleDelete = () => {
        setShow(false);
        alert("UI only — no delete action");
    };

    const handleCheckout = () => {
        alert("UI only — no backend functionality");
    };

    return (
        <>
            <div
                className={sidebar ? "taskMain " : "cx-active taskMain"}
                id="cx-main"
            >

                {loader ? (
                    <Loader />
                ) : (
                    <div id="cx-wrapper" className="AddOn_Settings_Cart">
                        <div className="row">
                            {addOnmyCardList.length > 0 ? (
                                <>
                                    {/* Left Side: Cart Items */}
                                    <div className="col-lg-8">
                                        <div className="main-cart-wrapper">
                                            <div className="Heading">
                                                <p>{t("My Cart")}</p>
                                                <p className="cart-count">{addOnmyCardList.length}</p>
                                            </div>

                                            <div className="cart-cards-wrapper">
                                                {addOnmyCardList.map((ele, index) => (
                                                    <div className="cart-card" key={index}>
                                                        <div className="cc-heading">
                                                            <p>{t(ele.addon_info_name)}</p>
                                                            <img
                                                                src={delete_icon}
                                                                alt=""
                                                                style={{ cursor: "pointer" }}
                                                                onClick={handleShow}
                                                            />
                                                        </div>
                                                        <div className="cc-body">
                                                            <div className="ao-card-table-wrapper">
                                                                <table className="ao-card-table">
                                                                    <thead className="ao-card-head">
                                                                        <tr>
                                                                            <th>
                                                                                {t(
                                                                                    `${ele.addon_pricing_addon_subscription_period ===
                                                                                        "monthly"
                                                                                        ? "Monthly"
                                                                                        : "Annually"
                                                                                    } Subscription`
                                                                                )}
                                                                            </th>
                                                                            <th>{t("Activation Price")}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="ao-card-body">
                                                                        <tr>
                                                                            <td>
                                                                                {ele.addon_pricing_addon_subscription_price ===
                                                                                    0
                                                                                    ? "Free"
                                                                                    : `${ele.addon_pricing_addon_subscription_price}${ele.currency_symbol}`}
                                                                            </td>
                                                                            <td>
                                                                                {ele.addon_pricing_addon_price === 0
                                                                                    ? "Free"
                                                                                    : `${ele.addon_pricing_addon_price}${ele.currency_symbol}`}
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right Side: Summary */}
                                    <div className="col-lg-4">
                                        <div className="main-summary-wrapper">
                                            <div className="order-summary">
                                                <div className="Heading">
                                                    <p>{t("Order Summary")}</p>
                                                </div>
                                                <div className="order-table-wrapper">
                                                    <table className="order-table">
                                                        {addOnmyCardList.map((ele, index) => (
                                                            <tbody key={index}>
                                                                <tr>
                                                                    <th>{t(ele.addon_info_name)}</th>
                                                                    <th>
                                                                        {ele.addon_pricing_addon_subscription_price ===
                                                                            0
                                                                            ? "Free"
                                                                            : `${ele.addon_pricing_addon_subscription_price}${ele.currency_symbol}`}
                                                                    </th>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        Activation fees -{" "}
                                                                        {ele.addon_pricing_addon_price === 0
                                                                            ? "Free"
                                                                            : `${ele.addon_pricing_addon_price}${ele.currency_symbol}`}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        ))}
                                                    </table>
                                                </div>

                                                <div className="order-total">
                                                    <p>{t("Total")}</p>
                                                    <p>
                                                        {addOnmyCardList
                                                            .reduce(
                                                                (total, item) =>
                                                                    total +
                                                                    parseFloat(
                                                                        item.addon_pricing_addon_subscription_price
                                                                    ),
                                                                0
                                                            )
                                                            .toFixed(2)}
                                                        $
                                                    </p>
                                                </div>

                                                <div className="cx-btn-2" onClick={handleCheckout}>
                                                    {t("Checkout Now")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className="col-lg-12">
                                    <div className="main-cart-wrapper">
                                        <div className="Heading">
                                            <p>{t("My Cart")}</p>
                                        </div>
                                        <div className="cart-bottom-section">
                                            <p>+ {t("Add more add-ons")} ?</p>
                                            <Link to="/AddOnSettings">{t("Click here")}...</Link>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Delete Modal */}
                <Modal show={show} onHide={handleClose} centered className="common-model">
                    <Modal.Header closeButton>
                        <Modal.Title>{t("Delete Add-on")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {t("Are you sure you want to delete this add-on from your cart?")}
                    </Modal.Body>
                    <Modal.Footer className="pop-up-modal-footer">
                        <div className="btn-wrapper">
                            <button className="cx-btn-1" onClick={handleClose}>
                                {t("Cancel")}
                            </button>
                            <button className="cx-btn-2" onClick={handleDelete}>
                                {t("Yes")}
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    );
};

export default AddOnSettingsCart;
